<template>
  <div class="calm">
    <div class="calm-click" @click="changeLogisticsDialogShow(true)"></div>
    <div class="calm-top">
      <div class="calm-top-title">
        亚马逊FBA商品利润计算系统 <span class="calm-top-title__tip">(适合选品利润预算或竞争对手商品利润估算)</span>
      </div>
      <div class="calm-top-rate">
        汇率更新({{ rateUpdateTime }})
        <div class="calm-top-block" v-for="(item, index) in currencyExchange" :key="index">
          <img :src="countryIcon[index]" alt="">{{country[index]}}:{{item.rate.toFixed(4)}}
        </div>
      </div>
    </div>
    <inputModule
      :budget-profit-data="budgetInputData"
      :is-prompt="isPromptInput"
      :is-prompt-by-logistics="isPromptInputByLogistics"
      @budgetChange="changeBudgetComponentData"></inputModule>
    <div class="calm-bottom">
      <div class="calm-btn" @click="importTrialData()">导入试用数据</div>
      <div class="calm-btn" @click="clearInputData()">清&nbsp;空&nbsp;数&nbsp;据</div>
      <div class="calm-btn" @click="changeCalmDialogshow(true)">利&nbsp;润&nbsp;计&nbsp;算</div>
    </div>
    <calmDialog :show="showCalmDialog"
      :budget-profit-data="budgetInputData"
      :is-disablle="false"
      @budgetChange="changeBudgetComponentData"
      @openTaxDialog="changeTaxDialogShow"
      @cancel="changeCalmDialogshow"></calmDialog>
    <el-dialog
      :visible.sync="showTaxDialog"
      width="850px"
      :append-to-body="true">
      <div class="calm-tax__title">
        {{ taxDialogData.title }} <span class="calm-tax__subtitle">({{ sqbsInputOptions[budgetInputData.sqbs] }})</span>
      </div>
      <div class="calm-tax">
        <div class="calm-tax__module">
          <div class="calm-tax__line" v-for="(item, index) in taxDialogData.input" :key="item.data">
            <div class="calm-tax__name">
              {{ item.name }}
              <template v-if="item.html">
                <img src="../img/问号.png" alt=""
                  class="calm-tax__img"
                  @mouseover="showDetailHtml(index)"
                  @mouseleave="cancelDetailHtml(index)">
                <div
                  class="calm-tax__detail"
                  :class="{'calm-tax__detail1': item.data === 'getTaxRefund'}"
                  v-html="item.html"
                  v-show="item.showDetail"></div>
              </template>
            </div>
            <div class="calm-tax__right">
              <div class="calm-tax__value">
                <template
                v-if="item.data === 'getSalesVATOnGoods'
                  || (item.data === 'getTaxRefund' && budgetInputData.sqbs == 1)
                  || (item.data === 'getImportTariffsOnGoods' && budgetInputData.sqbs == 0 )">
                  ￥0.00
                  <div
                    class="calm-tax__value--underline"
                    :class="{'calm-tax__value--underline1': typeTaxDialog != 'dialog'}"
                    v-if="budgetInputData.sqbs == 1">
                    ￥{{ keepDecimalPoint(budgetInputData[item.data]
                    * (typeTaxDialog == 'dialog' ? 1 : budgetInputData.getCalculateBasedOnActualSalesVolume), 2)}}
                  </div>
                </template>
                <template v-else>
                  ￥{{ keepDecimalPoint(budgetInputData[item.data]
                  * (typeTaxDialog == 'dialog' ? 1 :
                    item.data == 'getValueAddedTaxOnSalesOfGoods' ? budgetInputData.stockNum : budgetInputData.getCalculateBasedOnActualSalesVolume), 2)}}
                </template>
                <template v-if="typeTaxDialog != 'input'">{{ getUnitEnum('perUnit') }}</template>
              </div>
              <div class="calm-tax__pla">{{ item.pla }}</div>
            </div>
          </div>
          <div class="calm-tax__remark" v-if="taxDialogRemarkText !== ''">
            {{ taxDialogRemarkText }}
          </div>
        </div>
        <div class="calm-tax__line">
          <div class="calm-tax__name">{{ taxDialogDataLast.name }}</div>
          <div class="calm-tax__right">
            <div class="calm-tax__value">
              <template>
                ￥{{ keepDecimalPoint(typeTaxDialog == 'dialog'?
                  budgetInputData[taxDialogDataLast.data] : budgetInputData.importTariff, 2) }}
              </template>
              <template v-if="typeTaxDialog != 'input'">{{ getUnitEnum('perUnit') }}</template>
            </div>
            <div class="calm-tax__pla">{{ taxDialogDataLast.pla }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <logisticsDialog
      :show="showLogisticsDialog"
      :logistics-quotation="logisticsInputData"
      :unit="getUnitString()"
      @logisticsDataChange="changeLogisticsComponentData"
      @changeProductData="logisticsChangeProduct"
      @clear="logisticsInputData.clearData()"
      @cancel="changeLogisticsDialogShow"></logisticsDialog>
  </div>
</template>

<script>
  import inputModule from "./inputModule.vue";
  import calmDialog from './calmDialog.vue'
  import logisticsDialog from './logisticsDialog.vue'
  import { BudgetProfitTest, ProfitInputNewModule, INPUTENUM } from "common/dataClass/Profit";
  import { LogisticsQuotation } from 'common/dataClass/Logistics'
  import DefaultAxios from 'service/default'
  import globalData from 'common/globalData'
  export default {
    name: "calmModule",
    components: {
      'inputModule': inputModule,
      'calmDialog': calmDialog,
      'logisticsDialog': logisticsDialog
    },
    data(){
      return{
        /**预算计算基础数据 */
        budgetInputData: new BudgetProfitTest(),
        /**物流报价数据 */
        logisticsInputData: new LogisticsQuotation(),
        /**是否提示未输入数据的输入框 */
        isPromptInput: false,
        /**汇率更新时间 */
        rateUpdateTime: '',
        /**对应货币汇率 */
        currencyExchange: [],
        /**货币名称 */
        country: globalData.countryCurrencyInvariant.filter((item, index) =>
          globalData.countryCurrencyInvariant.indexOf(item) === index
        ),
        /**货币缩写 */
        countryAbbreviation: globalData.countryAbbreviationInvariant.filter((item, index) =>
          globalData.countryCurrencyInvariant.indexOf(item) === index
        ),
        /**是否显示计算弹窗 */
        showCalmDialog: false,
        /**是否显示物流弹窗 */
        showLogisticsDialog: false,
        /**物流弹窗所需数据是否提示 */
        isPromptInputByLogistics: false,
        /**国家图标 */
        countryIcon: [
          require('../../img/美国.jpg'),
          require('../../img/加拿大.jpg'),
          require('../../img/英国.jpg'),
          require('../../img/欧洲.jpg'),
          require('../../img/日本.jpg'),
          require('../../img/澳洲.jpg'),
          require('../../img/墨西哥.png')
        ],
        /**是否显示税务弹窗 */
        showTaxDialog: false,
        typeTaxDialog: '',
        /**税务弹窗数据 */
        taxDialogData: {},
        taxDialogDataLast: {},
        taxDialogRemarkText: '',
        /**双清包税选择项 */
        sqbsInputOptions: globalData.sqbsInputOptions,
        /**定时器 */
        detailTimer: null,
      }
    },
    created() {
      DefaultAxios.getRate().then(res => {
        this.rateUpdateTime = res.data.info.refreshTime;
        this.rateUpdateTime = new Date().Format('yyyy-MM-dd hh:mm')
        this.currencyExchange = res.data.info.rates;
        this.budgetInputData.setRate(res.data.info)
      }).catch(err => {
        if(err.data && err.data.code === 1020){
          sessionStorage.removeItem('JSESSIONID')
          DefaultAxios.getRate().then(res => {
            this.rateUpdateTime = res.data.info.refreshTime;
            this.rateUpdateTime = new Date().Format('yyyy-MM-dd hh:mm')
            this.currencyExchange = res.data.info.rates;
            this.budgetInputData.setRate(res.data.info)
          })
        }
      })
    },
    methods: {
      /**组件修改预算数据 */
      changeBudgetComponentData(obj){
        if(!obj) return
        this.budgetInputData[obj.key] = obj.value
      },
      /**组件修改物流报价数据 */
      changeLogisticsComponentData(obj){
        if(!obj) return
        this.logisticsInputData[obj.key] = obj.value
      },
      /**导入试用数据 */
      importTrialData(){
        DefaultAxios.importTrialDataTrackingPoints()
        this.budgetInputData.importTrialData()
      },
      /**清空数据 */
      clearInputData(){
        this.budgetInputData.clearData()
      },
      /**利润计算弹窗开关 */
      changeCalmDialogshow(bool){
        bool && DefaultAxios.profitCalculationTriggerPoint()
        let arr = this.budgetInputData.needArray()
        for(let i = 0; i < arr.length; i ++){
          if(!this.budgetInputData[arr[i]] && this.budgetInputData[arr[i]] != 0){
            this.isPromptInput = true
            this.$message.error('请将数据输入完整')
            return;
          }
        }
        this.showCalmDialog = bool
      },
      /**税务弹窗开关 */
      changeTaxDialogShow(obj){
        this.typeTaxDialog = obj.type
        let firstStr = this.typeTaxDialog == 'input' ? '' : '单位'
        this.taxDialogData.title = firstStr + '入口国自缴综合税'
        this.taxDialogDataLast.name = firstStr + '入口国自缴综合税'
        this.showTaxDialog = obj.bool
      },
      /**物流弹窗开关 */
      changeLogisticsDialogShow(bool){
        let obj = BudgetProfitTest.LOGISTICSVERITYDATA()
        let keys = Object.keys(obj)
        let entryBool = keys.every(k => this.budgetInputData[k] || this.budgetInputData[k] == 0)
        if(bool){
          if(entryBool){
            keys.map(k => this.logisticsInputData[obj[k]] = Number(this.budgetInputData[k]))
          }else{
            this.isPromptInputByLogistics = true
            this.$message.error('请将数据补充完整')
            return;
          }
        }
        this.showLogisticsDialog = bool
      },
      /**保留小数点数位 */
      keepDecimalPoint: globalData.keepDecimalPoint,
      /**获取对应的枚举单位 */
      getUnitEnum(unit){
        if(unit === INPUTENUM.NONE) return ''
        let arr = INPUTENUM.judgeEnumReturnString[unit]
        return arr[this.budgetInputData.unit]
      },
      /**鼠标停留在对应的输入框名称上 */
      showDetailHtml(index){
        const _this = this
        this.detailTimer = setTimeout(() => {
          _this.taxDialogData.input[index].showDetail = true
        }, 500);
      },
      /**鼠标离开对应的输入框名称上 */
      cancelDetailHtml(index){
        clearTimeout(this.detailTimer)
        this.detailTimer = null
        this.taxDialogData.input[index].showDetail = false
      },
      /**获取计价单位字符串 */
      getUnitString(){
        return globalData.unitInputOptions[this.budgetInputData.unit]
      },
      /**物流弹窗修改产品数据 */
      logisticsChangeProduct(obj){
        let keys = Object.keys(obj)
        for(let key of keys){
          this.budgetInputData[key] = obj[key]
        }
      },
      /**字符替换 */
      vatReplace(str){
        for(let i = 0; i < this.taxDialogData.input.length; i ++){
          this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, '(ADV)', '')
          this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, 'VAT', str)
          this.taxDialogData.input[i].html = globalData.replaceAll(this.taxDialogData.input[i].html, 'VAT', str)
          this.taxDialogRemarkText = globalData.replaceAll(this.taxDialogRemarkText, 'VAT', str)
        }
      }
    },
    computed: {
      /**判断税务弹窗文字是否需要修改 */
      changeTaxDialogDataBody(){
        let obj = {
          'countrySite': this.budgetInputData.countrySite,
          'xxts': this.budgetInputData.xxts,
          'sqbs': this.budgetInputData.sqbs
        }
        return obj
      },
    },
    watch: {
      changeTaxDialogDataBody(newVal){
        // 2026-11-29 不同国家税务逻辑整体修改
        /*
        let arr1 = globalData.europeIndexArray
        let arr2 = globalData.europeAndAmericaIndexArray
        let arr3 = globalData.aisaIndexArray
        if(arr1.includes(newVal.countrySite)){
          this.taxDialogData = ProfitInputNewModule.NEWTAXDATAEUROPE()
          if(newVal.sqbs == 0){
            this.taxDialogRemarkText = globalData.taxDialogRemarkText7
            this.taxDialogData.input[0].pla = '(物流公司自缴)'
            this.taxDialogData.input[1].pla = '(物流公司自缴)'
            this.taxDialogData.input[2].pla = '(物流公司自缴)'
            this.taxDialogData.input[4].pla = '(税务链断裂,不能退补税)'
          }else{
            this.taxDialogRemarkText = ''
            this.taxDialogData.input[0].pla = '(以自己税号自缴)'
            this.taxDialogData.input[1].pla = '(默认申请递延成功)'
            this.taxDialogData.input[2].pla = '(以自己税号自缴)'
            this.taxDialogData.input[4].pla = this.budgetInputData.getTaxRefund > 0 ? '(无申请递延才可补税)': '(无申请递延才可退税)'
          }
          // 澳洲将 VAT 替换成 GST, 并清掉(ADV)
          if(this.budgetInputData.countrySite == 8){
            for(let i = 0; i < this.taxDialogData.input.length; i ++){
              this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, '(ADV)', '')
              this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, 'VAT', 'GST')
              this.taxDialogData.input[i].html = globalData.replaceAll(this.taxDialogData.input[i].html, 'VAT', 'GST')
              this.taxDialogRemarkText = globalData.replaceAll(this.taxDialogRemarkText, 'VAT', 'GST')
            }
          }else if(this.budgetInputData.countrySite == 9){  // 墨西哥将 VAT 替换成 IVA, 并清掉(ADV)
            for(let i = 0; i < this.taxDialogData.input.length; i ++){
              this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, '(ADV)', '')
              this.taxDialogData.input[i].name = globalData.replaceAll(this.taxDialogData.input[i].name, 'VAT', 'IVA')
              this.taxDialogData.input[i].html = globalData.replaceAll(this.taxDialogData.input[i].html, 'VAT', 'IVA')
              this.taxDialogRemarkText = globalData.replaceAll(this.taxDialogRemarkText, 'VAT', 'IVA')
            }
          }
          // if(newVal.xxts == 0){
          //   // 直接调用filter无法改变Objcet属性的指向，需要使用defineProperty
          //   Object.defineProperty(this.taxDialogData, 'input', {
          //     value: this.taxDialogData.input.filter(v => v.data !== 'getTaxRefund')
          //   })
          // }
        }else if(arr2.includes(newVal.countrySite)){
          this.taxDialogData = ProfitInputNewModule.NEWTAXDATAEUROPEANDAMERICE()
          if(newVal.sqbs == 0){
            if(newVal.countrySite == 0){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText3
            }else if(newVal.countrySite == 1){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText8
            }else if(newVal.countrySite == 9){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText9
            }
          }else{
            if(newVal.countrySite == 0){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText4
            }else if(newVal.countrySite == 1){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText5
            }else if(newVal.countrySite == 9){
              this.taxDialogRemarkText = globalData.taxDialogRemarkText6
            }
          }
            for(let i = 0; i < 1; i ++){
              this.taxDialogData.input[i].pla =
                newVal.sqbs == 0 ?
                '(物流双清包税)' : '(以自己税号自缴)'
            }
        }else if(arr3.includes(newVal.countrySite)){
          this.taxDialogData = ProfitInputNewModule.NEWTAXDATAAISA()
          this.taxDialogRemarkText =
            newVal.sqbs == 0 ?
            globalData.taxDialogRemarkText2 :
            globalData.taxDialogRemarkText1
            for(let i = 0; i < 2; i ++){
              this.taxDialogData.input[i].pla =
                newVal.sqbs == 0 ?
                '(物流双清包税)' : '(以自己税号自缴)'
            }
        }
        this.taxDialogDataLast = this.taxDialogData.input.pop()
        */
       this.taxDialogData = ProfitInputNewModule.NEWTAXDATAEUROPE()
        if(newVal.sqbs == 0){
          this.taxDialogRemarkText = globalData.taxDialogRemarkText7
          this.taxDialogData.input[0].pla = '(物流公司自缴)'
          this.taxDialogData.input[1].pla = '(物流公司自缴)'
          this.taxDialogData.input[2].pla = '(物流公司自缴)'
          this.taxDialogData.input[4].pla = '(税务链断裂,不能退补税)'
        }else{
          this.taxDialogRemarkText = ''
          this.taxDialogData.input[0].pla = '(以自己税号自缴)'
          this.taxDialogData.input[1].pla = '(默认申请递延成功)'
          this.taxDialogData.input[2].pla = '(以自己税号自缴)'
          this.taxDialogData.input[4].pla = this.budgetInputData.getTaxRefund > 0 ? '(无申请递延才可补税)': '(无申请递延才可退税)'
        }
        // 澳洲以及加拿大将 VAT 替换成 GST, 并清掉(ADV)
        if([1, 8].includes(this.budgetInputData.countrySite)){
          this.vatReplace('GST')
        }else if(this.budgetInputData.countrySite == 9){  // 墨西哥将 VAT 替换成 IVA, 并清掉(ADV)
          this.vatReplace('IVA')
        }else if(this.budgetInputData.countrySite == 0){  // 美国将 VAT 替换成 TAX, 并清掉(ADV)
          this.vatReplace('TAX')
        }else if(this.budgetInputData.countrySite == 7){  // 日本将 VAT 替换成 JCT, 并清掉(ADV)
          this.vatReplace('JCT')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
::v-deep{
  .el-dialog__body{
    padding: 0 20px 30px;
  }
}
.calm{
  position: relative;
  width: 1500px;
  justify-content: space-between;
  border-radius: 5px;
  background-color: #fff;
  overflow-x: visible;
  margin: 10px auto;
  padding: 0 10px;
  &-click{
    position: absolute;
    top: 0;
    right: 0;
    width: 10px;
    height: 10px;
    &:hover{
      cursor: pointer;
    }
  }
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-title{
      color: #000;
      text-align: start;
      font-weight: bold;
      border-bottom: 1px solid #f1f4f9;
      font-size: 24px;
      padding: 5px;
      &__tip{
        color: #19ACFD;
        font-size: 15px;
      }
      &::after{
        content:'';
        display: block;
        border-bottom:5px solid #ff7f17;
        width: 40px;
        transform: translateX(80px);
      }
    }
    &-rate{
      display: flex;
      font-size: 12px;
      color: #7f7f7f;
      font-weight: 400;
      line-height: 20px;
    }
    &-block{
      margin: 0 5px;
      img{
        width: 17px;
        transform: translateY(2px);
        margin: 0 2px;
      }
    }
  }
  &-bottom{
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;
  }
  &-btn{
    font-size: 14px;
    background: #2d9ae4;
    color: white;
    font-weight: bold;
    padding: 10px 20px;
    border-radius: 3px;
    margin: 0 10px;
    &:hover{
      cursor: pointer;
      opacity: .8;
    }
  }
  &-tax{
    &__title{
      font-size: 20px;
      font-weight: bold;
      color: black;
      padding: 0px 5px 10px;
    }
    &__subtitle{
      font-size: 14px;
      color: #ff7f17;
      font-weight: normal;
      margin-left: 5px;
    }
    &__module{
      border-top: 0.5px solid rgb(129, 129, 129);
      border-bottom: 1px dashed rgb(104, 104, 104);;
    }
    &__line{
      display: flex;
      justify-content: space-between;
      margin: 10px;
    }
    &__name{
      flex: 1;
      position: relative;
    }
    &__right{
      flex: 1;
      color: #00a0c7;
      position: relative;
      display: flex;
      justify-content: space-between;
    }
    &__value{
      position: relative;
      &--underline{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: -100%;
        color: #ff7f17;
        text-decoration: line-through;
      }
      &--underline1{
        left: -180%;
      }
    }
    &__remark{
      margin: 10px;
      line-height: 20px;
      font-size: 12px;
      color: rgb(0, 160, 199);
    }
    &__img{
      width: 12px;
      transform: translate(0px, 1px);
    }
    &__detail{
      position: absolute;
      background-color: #dbedfc;
      top: 10px;
      left: 0px;
      color: black;
      font-size: 12px;
      z-index: 10;
      line-height: 15px;
      border: 1px solid #a8a8a8;
      border-radius: 8px;
      padding: 5px;
      // width: 400px;
      &::after{
        content: '';
        position: absolute;
        left: 8px;
        top: -6px;
        width: 10px;
        height: 10px;
        margin-bottom: -10px;
        background: inherit;
        /*自动继承父元素的背景*/
        transform: rotate(45deg);
        border-left: 1px solid #a8a8a8;
        border-top: 1px solid #a8a8a8;
      }
    }
    &__detail1{
      width: 500px;
    }
  }
}
</style>
